// src/pages/OAuthSuccessPage.tsx
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

const OAuthSuccessPage: React.FC = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const name = params.get('name');
    const email = params.get('email');
    const hasPlan = params.get("has_plan") === "1";
    console.log("OAuth Success:", { name, email, hasPlan });
    if (token) {
      localStorage.setItem('authToken', token);
      localStorage.setItem('user', JSON.stringify({ name, email }));
      console.log("User data saved:", { name, email });
      navigate(hasPlan ? '/dashboard' : '/choose-plan', { replace: true });
    } else {
      navigate('/login'); // fallback
    }
  }, [navigate]);

  return (
    <div style={{ textAlign: 'center', paddingTop: '3rem' }}>
      <h2>Signing you in…</h2>
    </div>
  );
};

export default OAuthSuccessPage;
